module.exports = __webpack_public_path__ + "img/logo-shiba888.724dcaea.png";